import { render } from "./AvaliacaoLista.vue?vue&type=template&id=94e38180"
import script from "./AvaliacaoLista.vue?vue&type=script&lang=js"
export * from "./AvaliacaoLista.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__